// Development Environment (AWS/Azure)
// Real APIs and Azure AD authentication

export const environment = {
  production: false,
  
  // Backend API URLs
  backofficeApiUrl: 'https://api.insurance-hub.deloitte.it/pal-bff-backoffice',
  professionalsApiUrl: 'https://azda7qdv6d.execute-api.eu-west-1.amazonaws.com/pal-bff-professionals',
  coreApiUrl: 'https://api.insurance-hub.deloitte.it/pal-dmn-core',
  palDmnDocuments:  'https://api.insurance-hub.deloitte.it/pal-bff-backoffice',
  palDmnContracts:  'https://api.insurance-hub.deloitte.it/pal-bff-backoffice',
  palDmnSuppliers:  'https://api.insurance-hub.deloitte.it/pal-bff-backoffice',
  
  // Azure AD Authentication
  azureAd: {
    tenantId: '36da45f1-dd2c-4d1f-af13-5abe46b99921',
    clientId: '6fd7d274-1052-4c41-80e6-133e35705485',
    redirectUri: 'https://insurance-hub.deloitte.it/auth/callback',
    scopes: ['6fd7d274-1052-4c41-80e6-133e35705485/.default'],
  },
  
  // Development/Testing Flags
  useMockAuth: false,
  disableAuthGuards: false,

  // When true, effective roles are fetched from pal-dmn-core GET /api/v1/me/roles
  // (header/CIAM enrichment) with fallback to client-side JWT decode.
  useServerRoles: true,

  // PAL role codes (non-prod) - logical role -> JWT role code
  roleCodes: {
    professional: 'PALPNONPRODROLE',
    collaborator: 'PALCNONPRODROLE',
    backoffice_professional: 'PALBPNONPRODROLE',
    backoffice_supplier: 'PALBSNONPRODROLE',
    backoffice_admin: 'PALBANONPRODROLE',
    admin: 'PALANONPRODROLE',
  },
};
